import Main from '../views/pcHome/main.vue'

const appRouter = [{
        path: '/',
        name: 'first',
        redirect: '/home',
        // component: () => import('@/views/pcBody/firstPage.vue'),
        meta: { keepAlive: true }
    },
    {
        path: '/home',
        name: 'home',
        component: () =>
            import ('@/views/pcHome/home.vue'),
        meta: { keepAlive: true }
    },
    {
        path: '/export',
        name: 'export',
        component: () =>
            import ('@/views/pcBody/exportPDFs.vue'),
    },
    {
        path: '/unitexport',
        name: 'unitexport',
        component: () =>
            import ('@/views/pcBody/unitexportPDF.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('@/views/pcHome/login.vue'),
        meta: { keepAlive: true }
    },
    {
        path: '/error',
        name: 'error',
        component: () =>
            import ('@/views/pcHome/error.vue'),
        meta: { keepAlive: false }
    },
    {
        path: '/news',
        name: 'news',
        component: Main,
        children: [{
                path: 'detail',
                name: 'detail',
                component: () =>
                    import ('@/views/pcBody/detail.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'law',
                name: 'law',
                component: () =>
                    import ('@/views/pcBody/law.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'vipApply',
                name: 'vipApply',
                component: () =>
                    import ('@/views/pcBody/vipApply.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'addUnit',
                name: 'addUnit',
                component: () =>
                    import ('@/views/pcBody/addUnit.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'Review',
                name: 'Review',
                component: () =>
                    import ('@/views/pcBody/review.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'alllist',
                name: 'alllist',
                component: () =>
                    import ('@/views/pcBody/list.vue'),
                meta: { keepAlive: true }
            },
            {
                path: 'tab',
                name: 'tab',
                component: () =>
                    import ('@/views/pcBody/tab.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'activelist',
                name: 'activelist',
                component: () =>
                    import ('@/views/pcBody/activeList.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'activedetail',
                name: 'activedetail',
                component: () =>
                    import ('@/views/pcBody/activeDetail.vue'),
                meta: { keepAlive: false }
            },
        ]
    },
    {
        path: '/laboursinfo',
        name: 'laboursinfo',
        component: Main,
        children: [{
                path: 'labourinfo',
                name: 'labourinfo',
                component: () =>
                    import ('@/views/pcBody/labourinfo.vue'),
                meta: { keepAlive: true }
            },


        ]
    },

    {
        path: '/more',
        name: 'more',
        component: Main,
        children: [{
                path: 'doc',
                name: 'doc',
                component: () =>
                    import ('@/views/pcBody/more.vue'),
                meta: { keepAlive: true }
            },
            {
                path: 'info',
                name: 'info',
                component: () =>
                    import ('@/views/pcBody/info.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'labourinfos',
                name: 'labourinfos',
                component: () =>
                    import ('@/views/pcBody/labourinfos.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'docInfo',
                name: 'docInfo',
                component: () =>
                    import ('@/views/pcBody/docInfo.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'photoes',
                name: 'photoes',
                component: () =>
                    import ('@/views/pcBody/photoes.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'search',
                name: 'search',
                component: () =>
                    import ('@/views/pcBody/search.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'workorlearn',
                name: 'workorlearn',
                component: () =>
                    import ('@/views/pcBody/workorlearn.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'commitdoc',
                name: 'commitdoc',
                component: () =>
                    import ('@/views/pcBody/commitdoc.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'wlDetail',
                name: 'wlDetail',
                component: () =>
                    import ('@/views/pcBody/wlDetail.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'feedback',
                name: 'feedback',
                component: () =>
                    import ('@/views/pcBody/feedback.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'mistake',
                name: 'mistake',
                component: () =>
                    import ('@/views/pcBody/mistake.vue'),
                meta: { keepAlive: false }
            },
            {
                path: 'mistakeInfo',
                name: 'mistakeInfo',
                component: () =>
                    import ('@/views/pcBody/mistakeInfo.vue'),
                meta: { keepAlive: false }
            }
        ]
    }
]

export default appRouter


// WEBPACK FOOTER //
// ./src/router/router.js